import type { FC, ComponentType } from "react";

import styled from "styled-components";

import type { IconName } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { ButtonType } from "@similarweb/ui-components";
import { Button, FlexRow, IconButton, ItemIcon, ItemIconChain } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const VSWrapper = styled(FlexRow)`
    ${setFontVariant("body1", colorsPalettes.carbon[300])};
    letter-spacing: 0.7px;
    margin-right: 8px;
    margin-left: 8px;
    flex: 0 0 auto;
    height: 32px;
    align-items: center;
`;

interface IDomainCompareSelector {
    sites: { name: string; icon: string }[];
    domainsArr: string;
    onClick?: () => void;
    maxSuggestedSites?: number;
    container?: ComponentType<any>;
    buttonVariant?: ButtonType;
    iconName?: IconName;
}
const DomainCompareSelector: FC<IDomainCompareSelector> = ({
    sites,
    domainsArr,
    onClick,
    maxSuggestedSites = 4,
    container: ContainerComponent,
    buttonVariant = "primary",
    iconName,
}) => {
    const handleCompareClick = () => {
        onClick?.();
        const currentState = proNavigator.current();
        const params = { key: domainsArr, ...(currentState.reset ?? {}) };
        proNavigator.updateParams(params);
    };
    const [primaryDomain, ...secondarySites] = sites;

    const secondaryIcons = secondarySites.slice(0, maxSuggestedSites).map((site) => site.icon);

    const Container = ContainerComponent || CenteredFlexRow;

    return (
        <Container style={{ gap: "16px" }}>
            <CenteredFlexRow>
                <CenteredFlexRow style={{ gap: "8px" }}>
                    <ItemIcon iconSrc={primaryDomain.icon} />
                    <Text fontVariant="input2">{primaryDomain.name}</Text>
                </CenteredFlexRow>
                <VSWrapper>{translate("compared.duration.vs")}</VSWrapper>
                <ItemIconChain
                    icons={secondaryIcons}
                    size={34}
                    counterBoxWidth={34}
                />
            </CenteredFlexRow>
            {iconName ? (
                <IconButton
                    onClick={handleCompareClick}
                    key="compare-btn-add"
                    type={buttonVariant}
                    iconName={iconName}
                >
                    {translate("analysis.header.btn")}
                </IconButton>
            ) : (
                <Button
                    onClick={handleCompareClick}
                    key="compare-btn-add"
                    type={buttonVariant}
                >
                    {translate("analysis.header.btn")}
                </Button>
            )}
        </Container>
    );
};

export default DomainCompareSelector;
